import clsx from 'clsx'
import dayjs from 'dayjs'
import SimpleBar from 'simplebar-react'

import useCall from '~/hooks/useCall'

const VisitorAwaiting = () => {
  const { isQueueStarted, callData, selectQueue, selectedTicket, currentServing } = useCall()

  return (
    <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-lg bg-white p-4">
      {isQueueStarted ? (
        <>
          {callData.antrian_list.length > 0 ? (
            <>
              <div className="absolute left-0 top-0 z-20 w-full p-4">
                <div className="rounded-lg bg-jba-blue/10 p-2 text-center text-sm font-medium text-jba-blue shadow-lg backdrop-blur-md">
                  {callData.antrian_list.length} visitor{callData.antrian_list.length > 1 && 's'} are awaiting
                </div>
              </div>
              <SimpleBar className="relative min-h-0 flex-1 pr-4 pt-12" forceVisible="y" autoHide={false}>
                {callData.antrian_list.map((ticket, index) => {
                  const isSelected = selectedTicket.queue_id === ticket.queue_id
                  // Queue taken with a pickup kode unik - shown in red so CS can tell it apart
                  const isKodeUnik = ticket.is_kode_unik

                  return (
                    <button
                      type="button"
                      key={index}
                      className={clsx(
                        'relative z-0 mt-4 w-full rounded-lg px-6 py-4 text-sm first:mt-0',
                        'before:absolute before:inset-y-0 before:z-10 before:my-auto before:inline-block before:h-5 before:w-2.5 before:rounded-r-full before:bg-white',
                        'after:absolute after:inset-y-0 after:z-10 after:my-auto after:inline-block after:h-5 after:w-2.5 after:rounded-l-full after:bg-white',
                        isSelected && 'pointer-events-none text-white before:left-0 after:right-0',
                        isSelected && (isKodeUnik ? 'bg-red-600' : 'bg-jba-blue'),
                        !isSelected &&
                          !isKodeUnik &&
                          'bg-gray-100 text-jba-blue before:left-0 after:right-0 hover:bg-gray-200',
                        !isSelected &&
                          isKodeUnik && [
                            'border border-red-300 bg-red-50 text-jba-blue hover:bg-red-100',
                            // shift the ticket notches over the 1px border and outline them, so the red border follows the cut-out
                            'before:-left-px before:border before:border-l-0 before:border-red-300',
                            'after:-right-px after:border after:border-r-0 after:border-red-300',
                          ],
                      )}
                      disabled={currentServing.isIdle}
                      onClick={() => selectQueue(ticket.queue_id, 'queue')}
                    >
                      <div className="flex items-start justify-between gap-4">
                        <div className="space-y-1 text-left text-xs">
                          <div className="flex gap-2">
                            <div className="font-bold">Ticket No.</div>
                            <div>
                              {ticket.queue_no} - {ticket.queue_secret_code}
                            </div>
                          </div>
                          <div className="flex gap-2">
                            <div className="font-bold">Issue Date :</div>
                            <div>{dayjs(ticket.created_at).format('DD-MM-YYYY HH:mm:ss')}</div>
                          </div>
                        </div>
                        <div className="flex flex-col items-end text-right text-xs">
                          <div className="font-bold opacity-70">Keperluan</div>
                          <div className={clsx('font-bold', !isSelected && 'text-jba-blue')}>
                            {ticket.queue_necessary || '-'}
                          </div>
                        </div>
                      </div>
                    </button>
                  )
                })}
              </SimpleBar>
            </>
          ) : (
            <div className="flex flex-1 items-center justify-center text-gray-400">Belum ada antrean.</div>
          )}
        </>
      ) : (
        <div className="flex flex-1 items-center justify-center text-gray-400">Antrean belum dimulai.</div>
      )}
    </div>
  )
}

export default VisitorAwaiting
